/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const subscriptionPurchaseRequestRequestSchema = z
	.object({
		return_url: z.url().nullish(),
		email: z.email().min(1).nullish(),
		org_unit: z.uuid().nullish(),
	})
	.describe("Запрос на инициацию покупки подписки.");
